function trackYouleadVirtualPageView(pageId) {
  const ylData = (window.ylData = window.ylData || []);
  ylData.push({ page: { extendedValue: pageId } });

  return ylData;
}

export default trackYouleadVirtualPageView;
